import { AT } from '../../../actions/actionTypes';
import { State, SetModePL, InfoState } from './model';
import { StateDefault } from './defaults';
import SendReducer from './send.reducer';
import RequestReducer from './request.reducer';
import ActivitiesReducer from './activities.reducer';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: State = StateDefault;

export default function (state = defaultState, action: any) {
    const newState: State = {
    ...state,
    send: SendReducer(state.send, action),
    request: RequestReducer(state.request, action),
    activities: ActivitiesReducer(state.activities, action)
  };

  switch (action.type) {
    case AT.DIALOG_TRANSFER_SETMODE: {
      Logger.info([AT.DIALOG_TRANSFER_SETMODE, action], LogArea.Redux);
      const { screen }: SetModePL = action.payload;
      return { ...newState, screen };
    }
    case AT.DIALOG_TRANSFER_DEVICES_CHANGED: {
      Logger.info([AT.DIALOG_TRANSFER_DEVICES_CHANGED, action], LogArea.Redux);
      const { transferId, devices }: InfoState = action.payload;
      const info = { transferId, devices };
      return { ...newState, info};
    }

    default: {
      return newState;
    }
  }
}
